import { EpimsBaseEntityDto } from './epim-base.dto';
export class AccountableFunctionDto extends EpimsBaseEntityDto {
  AccountableFunctionName: string;
  FunctionId: string;
  FunctionalEmail: string;
  TeamLead: string;
}
